import React from 'react'
import dynamic from 'next/dynamic'
import BarraCupom from 'src/components/barra-cupom'
import { OverlayCart, StyleNewHeader } from '../styles'
import { HeaderDesktop } from './HeaderDesktop'
import { useRouter } from 'next/router'
import { logout } from '../../../services/auth'
import { useBreakpointValue } from '@gazin/ecommerce-ui'

const CategoriaMobile = dynamic(() => import('../../categoria-mobile'), {
  ssr: false,
})
const MobileMenu = dynamic(() => import('./MobileMenu'), {
  ssr: false,
})

export function HeaderDefault({
  initialColor,
  finalColor,
  textColor,
  buttonColor,
  baseColor,
  sidebar,
  setSidebar,
  logado,
  showZipcodeBox,
  setShowZipcodeBox,
  activeDropdownUser,
  hideDropdownUser,
  isBlackFridayTheme,
  buttonCartTextColor,
}) {
  const router = useRouter()

  const AvatarTheo = isBlackFridayTheme ? 'blackfriday-theo.png' : 'theo.png'
  const ImageTheo = `${process.env.INTERNAL_IMAGES_URL}/images/png/${AvatarTheo}`

  const sair = (e) => {
    e.preventDefault()
    router.reload()
    logout()
  }

  const isMobile = useBreakpointValue({
    base: true,
    md: true,
    lg: true,
    xl: false,
  })

  return (
    <header className="cabecalho-paginas">
      <BarraCupom />

      <StyleNewHeader
        darkTheme={isBlackFridayTheme}
        initialColor={initialColor}
        finalColor={finalColor}
        textColor={textColor}
        buttonColor={buttonColor}
        baseColor={baseColor}
        buttonCartTextColor={buttonCartTextColor}
      >
        <CategoriaMobile />

        <MobileMenu sidebar={sidebar} setSidebar={setSidebar} logado={logado} />

        <HeaderDesktop
          buttonColor={buttonColor}
          logado={logado}
          showZipcodeBox={showZipcodeBox}
          setShowZipcodeBox={setShowZipcodeBox}
          ImageTheo={ImageTheo}
          activeDropdownUser={activeDropdownUser}
          hideDropdownUser={hideDropdownUser}
          textColor={textColor}
          sair={sair}
          isMobile={isMobile}
          buttonCartTextColor={buttonCartTextColor}
        />
      </StyleNewHeader>

      <OverlayCart>
        <div className="overlay" />
      </OverlayCart>
    </header>
  )
}
